<template>
  <div>
    <select-shop
      :loadingButton="loadingButton"
      v-on:getData="getData"
    ></select-shop>

    <div >
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="p-0 tabs">
              <input type="radio" id="tab1" name="tab-control" checked />
              <input type="radio" id="tab2" name="tab-control" />
              <ul class="ulbar font-weight-normal text-dark">
                  <li :title="$t('shopPromotion')">
                      <label for="tab1" role="button">
                        <img src="/img/delivery/store.png" alt="store Icon" class="d-lg-none d-md-none" style="width: 24px; height: 24px;" />
                          <br /><span> {{ $t('shopPromotion') }}</span>
                      </label>
                  </li>
                  <li :title="$t('grabPromotion')">
                      <label for="tab2" role="button">
                        <img src="/img/delivery/grab.png" alt="Money Icon" class="d-lg-none d-md-none" style="width: 24px; height: 24px;" />

                          <br /><span> {{ $t('grabPromotion') }}</span>
                      </label>
                  </li>
              </ul>
              <div class="slider">
                  <div class="indicator"></div>
              </div>
              <div class="content">
                  <section class="text-dark" >
                      <template>
                        <div v-if="isSilomPromotionEnabled">
                          <div class="table">
                              <div class="row">
                                  <div class="col-10">
                                      <h3 class="font-weight-normal text-dark">{{ $t('shopPromotion') }}
                                      </h3>
                                      <show-date  class="font-weight-normal text-dark"></show-date>
                                  </div>           
                              </div>
                          </div>
                          <CRow class="mb-4">
                            <CCol sm="6" md="3">
                              <CCard class="modern-stat-card border-0 border-left-info shadow-sm h-100">
                                <CCardBody class="d-flex justify-content-between align-items-center m-0 pt-0 pb-0" style="padding-top: 0rem; padding-bottom: 0rem;">
                                  <div class="stat-content">
                                    <div class="stat-label mb-0">{{ $t('usedPromotion') }}</div>
                                    <div class="stat-value text-dark m-0">{{ promotionSummary.successCount }}</div>
                                    <div class="stat-badge bg-light-success text-success">
                                      <i class="cil-arrow-top mr-1"></i>{{ $t("all") }} {{ ((promotionSummary.totalUsage )) }}
                                    </div>
                                  </div>
                                  <div class="progress-vertical bg-light-info">
                                    <div class="progress-bar-inner bg-info" :style="{ height: (promotionSummary.successCount / promotionSummary.totalUsage * 100) + '%' }">
                                   
                                     <span class="progress-text">
                                      {{ promotionSummary.totalUsage > 0 ? ((promotionSummary.successCount / promotionSummary.totalUsage) * 100).toFixed(0) : 0 }}%
                                    </span>
                                    </div>
                                  </div>
                                </CCardBody>
                              </CCard>
                            </CCol>
                            <CCol sm="6" md="3">
                              <CCard class="modern-stat-card border-0 border-left-danger shadow-sm h-100">
                                <CCardBody class="d-flex justify-content-between align-items-center" style="padding-top: 0rem; padding-bottom: 0rem;">
                                  <div class="stat-content">
                                    <div class="stat-label text-danger m-0">{{ $t('cancelled') }}</div>
                                    <div class="stat-value text-dark m-0">{{ promotionSummary.cancelCount }}</div>
                                    <div class="small text-muted">{{$t('amount')}} {{ promotionSummary.cancelDiscountCalculated  }}</div>
                                  </div>
                                  <div class="progress-vertical bg-light-danger">
                                    <div class="progress-bar-inner bg-danger" :style="{ height: (promotionSummary.cancelCount / promotionSummary.totalUsage * 100) + '%' }">
                                      <span class="progress-text">
                                        {{ promotionSummary.totalUsage > 0 ? ((promotionSummary.cancelCount / promotionSummary.totalUsage) * 100).toFixed(0) : 0 }}%
                                      </span>
                                    </div>
                                  </div>
                                </CCardBody>
                              </CCard>
                            </CCol>
                            <CCol sm="6" md="3">
                              <CCard class="modern-stat-card border-0 border-left-success shadow-sm h-100">
                                <CCardBody class="d-flex justify-content-between align-items-center" style="padding-top: 0rem; padding-bottom: 0rem;">
                                  <div class="stat-content">
                                    <div class="stat-label">{{$t('discountTotal')}}</div>
                                    <div class="stat-value text-dark mb-0">{{ promotionSummary.successDiscountCalculated  }}</div>
                                    <div class="small text-muted mb-0">{{$t('avgPromo')}} {{ (promotionSummary.successDiscountCalculated / promotionSummary.successCount || 0).toFixed(2) }}</div>
                                  </div>
                                  <div class="progress-vertical bg-light-success">
                                    <div class="progress-bar-inner bg-success" :style="{ height: (promotionSummary.successDiscountCalculated / promotionSummary.discountCalculated * 100) + '%' }">
                                      <span class="progress-text">
                                        {{ promotionSummary.discountCalculated > 0 ? ((promotionSummary.successDiscountCalculated / promotionSummary.discountCalculated) * 100).toFixed(0) : 0 }}%
                                      </span>
                                    </div>
                                  </div>
                                </CCardBody>
                              </CCard>
                            </CCol>
                            <CCol sm="6" md="3">
                              <CCard class="modern-stat-card border-0 border-left-warning shadow-sm h-100">
                                <CCardBody class="d-flex justify-content-between align-items-center" style="padding-top: 0rem; padding-bottom: 0rem;">
                                  <div class="stat-content">
                                    <div class="stat-label mb-0">{{ $t("billAmount") }} </div>
                                    <div class="stat-value text-dark mb-0">{{ promotionSummary.receiptCount  }} {{ $t("bill") }}</div>
                                    <div class="stat-badge bg-light-warning text-warning">
                                      {{ $t("total") }} {{ promotionSummary.totalDiscounttext }} 
                                    </div>
                                  </div>
                                  <div class="progress-vertical bg-light-warning">
                                    <div class="progress-bar-inner bg-warning" style="height: 45%">
                                      <span class="progress-text"></span>
                                    </div>
                                  </div>
                                </CCardBody>
                              </CCard>
                            </CCol>
                          </CRow>
                          <CRow class="justify-content-between ">
                            <CCol sm="12" md="6" lg="5">
                              <CCard class="border-0 shadow-sm">
                                  <CCardBody>
                                      <h5 class="font-weight-bold mb-4 text-dark">{{$t('topFivePromotion')}}</h5>
                                      <CRow>
                                          <CCol lg="6" class="custom-scroll pr-2" style="max-height: 370px; overflow-y:auto;">
                                              <CCallout v-for="(list, index) in dataTopFivePromotion.slice(0, 5)" :key="index"
                                                  :style="{
                                                      borderRadius: '10px',
                                                      margin: '0 0 10px 0',
                                                      borderLeft: '10px solid ' + getChartColor(index),
                                                      boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                                                      padding: '12px',
                                                      backgroundColor: getBackgroundColor(index)
                                                  }">
                                                  <div class="row align-items-center no-gutters">
                                                      <div class="col-1 text-center font-weight-bold text-dark">
                                                          {{ index + 1 }}.
                                                      </div>
                                                      <div class="col pl-3">
                                                          <strong class="text-dark d-block text-truncate">
                                                              {{ list.title }}
                                                          </strong>
                                                          <div class="small text-muted mt-1">
                                                              {{ $t("usageCount") }}: <span class="text-dark font-weight-bold">{{ list.usageCount }}</span>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </CCallout>
                                          </CCol>

                                          <CCol lg="6">
                                              <CChartDoughnut 
                                                  :datasets="itemTopFivePromotion.datasets"
                                                  :labels="itemTopFivePromotion.labels" 
                                                  :options="itemTopFivePromotion.chartOptions"
                                                  style="height: 415px;" 
                                              />
                                          </CCol>
                                      </CRow>
                                  </CCardBody>
                              </CCard>
                          </CCol>
                            <CCol sm="12" md="6" lg="7">
                              <CCard style="box-shadow: 0 0 0 1px #e5e5e5; overflow-x: auto">
                                <CCardBody>
                                  <h5>{{$t('promotionUsage')}}</h5>
                                  <CRow  class="mb-3">
                                    <CCol class="col-12 col-sm-10 mt-2">
                                        <input
                                            v-model="keyword"
                                            class="form-control"
                                            :placeholder="$t('keyword')"
                                            @keyup.enter="getSort(keyword)"
                                        />
                                    </CCol>
                                    <CCol class="col-12 col-sm-2 mt-2">
                                        <CButton @click="getSort(keyword)" color="success" block>
                                        {{ $t('search') }} 
                                        </CButton>
                                    </CCol>
                                </CRow>
                                  <DataTable
                                    style="white-space: nowrap"
                                    :items="itemPromotionDetail"
                                    :fields="fieldsPromotionStatus"
                                    clickableRows
                                    hover
                                    :loading="loading"
                                  >
                                  <template #title="{item}">
                                    <td class="align-middle">
                                      <div class="d-flex align-items-center">
                                        <div class="img-wrapper mr-3 shadow-sm" :style="{ backgroundColor: item.indexColor }">
                                          <img v-if="item.image" :src="item.image" class="promo-img" />
                                          <i v-else class="cil-tag text-white"></i>
                                        </div>
                                        <div>
                                          <div class="font-weight-bold text-dark mb-0">{{ item.title }}</div>
                                          <small class="text-muted text-uppercase" style="letter-spacing: 0.5px;">{{ item.promotionCode }}</small>
                                        </div>
                                      </div>
                                    </td>
                                  </template>
                                </DataTable>
                                  <pagination
                                    :meta_data="meta_data_detail"
                                    v-on:next="getPromotionDetail"
                                  ></pagination>
                                </CCardBody>
                              </CCard>
                            </CCol>
                          </CRow>
                          <CRow class="mt-4">
                            <CCol sm="12" lg="12">
                              <h5>{{ $t('promotionTransection') }}</h5>
                              <DataTable
                                style="white-space: nowrap"
                                :items="itemPromotionTransection"
                                :fields="fields"
                                clickableRows
                                hover
                                border             
                                :loading="loading"
                              >
                                <template #salesChannels="{ item }">
                                  <td class="text-left text-dark">
                                    <img
                                      :src="getSalesChannelImage(item.salesChannels)"
                                      alt="Icon"
                                      width="18"
                                      height="18"
                                      class="mr-1 align-middle"
                                    />
                                    {{ item.salesChannels }}
                                  </td>
                                </template>
                                <!-- @click="getUsageTransection(item)" -->
                                <template #promotionName="{item}">
                                  <td  class="text-left text-dark" > {{item.promotionName}}</td>
                                </template>
                                <template #totalAmount="{ item }">
                                  <td class="text-right text-dark">{{ item.totalAmount }}</td>
                                </template>
                                <template
                                  #details="{ item, index }"
                                  @click="paymentDetail(item.paymentObjectId)"
                                >
                                  <CCollapse :show="details.includes(item)">
                                    <CCardBody>
                                      <h5 class="font-weight-normal text-dark">
                                        {{ $t("items") }}
                                      </h5>
                                      <br />
                                      <table class="table table-striped">
                                        <th
                                          v-for="field in fieldsDetail"
                                          :class="field._classes" :key="field.objectId"
                                        >
                                          {{ field.label }}
                                        </th>
                                        <tr
                                          style="vertical-align: top"
                                          v-for="item in itemsDetail(index)"
                                          :key="item.objectId"
                                        >
                                          <td style="vertical-align: top">
                                            <!-- {{ item.receiptNumber }} -->
                                          </td>
                                          <td style="vertical-align: top">
                                            <!-- {{ item.pluCode }} -->
                                          </td>
                                          <td style="vertical-align: top">
                                            <!-- {{ item.pluName }} -->
                                            <br />
                                              <div>
                                              <ul>
                                                <li v-for="option in item.orderedOptions" :key="option.objectId">
                                                  <small class="text-muted">
                                                    {{ option.optionItemName }}
                                                  </small>
                                                </li>
                                              </ul>
                                            </div>
                                          </td>
                                          <td style="vertical-align: top" class="text-center">
                                            <!-- {{ item.quantitySKU }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.price }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.discountTotal }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.totalAmount }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.netAmount }} -->
                                          </td>
                                        </tr>
                                      </table>
                                      <table class="table table-borderless text-dark">
                                        <tr>
                                          <td
                                            class="text-right"
                                            style="width: 75%; border: none"
                                          >
                                            <strong class="font-weight-normal">
                                              {{ $t("discount") }}
                                            </strong>
                                          </td>
                                          <td class="text-right">
                                            <!--  -->
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="text-right" style="border: none">
                                            <strong class="font-weight-normal">
                                              {{ $t("totalAmount") }}
                                            </strong>
                                          </td>
                                          <td class="text-right">
                                            <!-- {{ item.serviceCharge }} -->
                                          </td>
                                        </tr>
                                      </table>
                                    </CCardBody>
                                  </CCollapse>
                                </template>
                              </DataTable>
                            </CCol>
                          </CRow>
                          <pagination
                            :meta_data="meta_data"
                            v-on:next="getPromotionTransection"
                          ></pagination>
                        </div>
                        <div v-else class="text-center">
                          <CImg src="/bn_promo_new.jpg" class="img-fluid text-center" width="80%" />
                        </div>
                        
                      </template>
                  </section>

                  <!-- Grab -->
                  <section>
                      <template>
                        <div v-if="isGrabOrderEnabled">
                          <div>
                              <h3 class="font-weight-normal text-dark">
                                  {{ $t('grabPromotion') }}
                              </h3>
                              <show-date  class="font-weight-normal text-dark"></show-date>

                          </div>
                          <CRow class="justify-content-between mt-4">
                            <CCol sm="12" md="5" lg="4">
                              <CCard style=" -webkit-box-shadow: unset; box-shadow: 0 0rem 0rem rgb(0 0 21 / 8%) !important;">
                                <CCardBody>
                                <h5>{{$t('topFivePromotion')}}</h5>
                                <CChartDoughnut :datasets="itemTopFiveGrabPromotion.datasets"
                                  :labels="itemTopFiveGrabPromotion.labels"
                                  :options="itemTopFiveGrabPromotion.chartOptions"
                                  style="height: 332px;align-items: center;" />
                                  </CCardBody>
                                </CCard>
                            </CCol>
                            <!-- <CRow class="mt-4"> -->
                            <CCol sm="12" lg="8">
                    
                              <h5>{{ $t('promotionTransection') }}</h5>
                              <!-- DataTable displaying data from items() method -->
                              <DataTable
                                style="white-space: nowrap"
                                :items="itemPromotionGrabTransection"
                                :fields="fieldsGrab"
                                clickableRows
                                hover
                                border
                              :loading="loading"
                              >
                              <!--  @row-clicked="toggleDetails" -->
                                <template #salesChannels="{ item }">
                                  <td class="text-left text-dark">
                                    <img
                                      :src="getSalesChannelImage(item.salesChannels)"
                                      alt="Icon"
                                      width="18"
                                      height="18"
                                      class="mr-1 align-middle"
                                    />
                                    {{ item.salesChannels }}
                                  </td>
                                </template>

                                <template #totalAmount="{ item }">
                                  <td class="text-right text-dark">{{ item.totalAmount }}</td>
                                </template>
                                <template
                                  #details="{ item, index }"
                                  @click="paymentDetail(item.paymentObjectId)"
                                >
                                  <CCollapse :show="details.includes(item)">
                                    <CCardBody>
                                      <h5 class="font-weight-normal text-dark">
                                        {{ $t("items") }}
                                      </h5>
                                      <br />
                                      <!-- :class="item._classes" -->
                                      <!--  :key="field.objectId" -->
                                      <table class="table table-striped">
                                        <th
                                          v-for="field in fieldsDetail"
                                          :class="field._classes"
                                        >
                                          {{ field.label }}
                                        </th>
                                        <tr
                                          style="vertical-align: top"
                                          v-for="item in itemsDetail(index)"
                                          :key="item.objectId"
                                        >
                                          <td style="vertical-align: top">
                                            <!-- {{ item.receiptNumber }} -->
                                          </td>
                                          <td style="vertical-align: top">
                                            <!-- {{ item.pluCode }} -->
                                          </td>
                                          <td style="vertical-align: top">
                                            <!-- {{ item.pluName }} -->
                                            <br />
                                            <div>
                                              <!--  v-for="option in item.orderedOptions"
                                                :key="option.objectId" -->
                                              <small class="text-muted">
                                                <li>
                                                  <!-- {{ option.optionItemName }} -->
                                                </li>
                                              </small>
                                            </div>
                                          </td>
                                          <td style="vertical-align: top" class="text-center">
                                            <!-- {{ item.quantitySKU }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.price }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.discountTotal }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.totalAmount }} -->
                                          </td>
                                          <td style="vertical-align: top" class="text-right">
                                            <!-- {{ item.netAmount }} -->
                                          </td>
                                        </tr>
                                      </table>
                                      <table class="table table-borderless text-dark">
                                        <tr>
                                          <td
                                            class="text-right"
                                            style="width: 75%; border: none"
                                          >
                                            <strong class="font-weight-normal">
                                              {{ $t("discount") }}
                                            </strong>
                                          </td>
                                          <td class="text-right">
                                            <!--  -->
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="text-right" style="border: none">
                                            <strong class="font-weight-normal">
                                              {{ $t("totalAmount") }}
                                            </strong>
                                          </td>
                                          <td class="text-right">
                                            <!-- {{ item.serviceCharge }} -->
                                          </td>
                                        </tr>
                                      </table>
                                    </CCardBody>
                                  </CCollapse>
                                </template>
                              </DataTable>
                              <pagination
                                :meta_data="meta_data_grab"
                                v-on:next="getGrabCanpaignTransection"
                              ></pagination>
                            </CCol>
                          </CRow> 
                        </div>
                        <div v-else>
                          <access-grab></access-grab>
                        </div>
                      </template>
                  </section>
              </div>
          </div>
        </CCardBody>
      </CCard>
      <div>

      <div
        v-if="showModal"
        class="modal fade show d-block "
        tabindex="-1"
        role="dialog"
        aria-labelledby="deliveryDetailsModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered  modal-item-detail" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deliveryDetailsModal">Promotion Details</h5>
              <button
                type="button"
                class="close"
                @click="showModal = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <!-- Header -->
              <div class="text-center mb-4">
                <img
                  :src="remoteImagePath"
                  alt="Grab Logo"
                  
                  style="height: 60px;"
                />
                <h4 class="mt-3">{{promotionName}}</h4>
                <p>{{ descriptionPromotion }}</p>
                <CRow>
                  <CCol>
                    <p>{{ $t('promotionStartDate') }}  <span>{{promotionStart}}</span></p>
                  </CCol>
                  <CCol>
                    <p>{{ $t('PromotionEndDate') }}  <span>{{promotionEnd}}</span></p>
                  </CCol>
                </CRow>
              </div>
              <hr/>
              <!-- Details Section -->
              <div class="text-center">
                <div class="chart-container">
                  <!-- <h2>Promotion Usage - Line Chart</h2> -->
                  <CChartLine
                    :datasets="lineDatasets"
                    :options="chartOptions"
                    :labels="lineLabels"
                  />

                  <CChartDoughnut
                    :datasets="doughnutDatasets"
                    :options="chartOptions"
                    :labels="doughnutLabels"
                  />
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Order No</th>
                        <th>Grand Total</th>
                        <th>Discount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(transaction, index) in transactions" :key="transaction._id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ transaction.receipt.orderNo }}</td>
                        <td>{{ transaction.receipt.grandTotal | currency }}</td>
                        <td>{{ transaction.discountCalculated | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination
                    :meta_data="meta_data_promotion_usage"
                    v-on:next="getUsageTransection"
                  ></pagination>
                </div>
            
              </div>
            </div>

          </div>
        </div>
      </div>
      <div
        v-if="showModal"
        class="modal-backdrop fade show"
        @click="showModal = false"
      ></div>
    </div>
    </div>

  </div>

</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "@/services/service";
import report from "@/services/report";
import Pagination from "@/containers/Pagination";
import Sortdata from "@/containers/SortData";
import DataTable from "@/containers/DataTable"; // Your original DataTable
import { CChartLine, CChartDoughnut } from "@coreui/vue-chartjs";
import permis from "@/util/permission";
import util from "@/util/util";
import pos from "@/services/local";
import HelpButton from "../../containers/HelpButton.vue";
import "@/util/tabs.css";
import { sum } from "lodash";

export default {
  components: {
    Pagination,
    Sortdata,
    DataTable,
    CChartLine,
    HelpButton,
    CChartDoughnut
  },
  data() {
    return {
      promotionName : '',
      remoteImagePath : '',
      descriptionPromotion : '',
      promotionStart : '',
      promotionEnd : '',
      keyword : '',
      showChartLine: false,
      dataDate: [],
      data: [],
      meta_data_grab : {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      meta_data_detail: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      meta_data_promotion_usage : {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      loadingButton: true,
      sortOrder: "asc",
      sortdata: "sortBySalesMin",
      sortnum: false,
      sort_value: {
        sortBySalesMin: "sortBySalesMin",
        sortBySalesMax: "sortBySalesMax",
        sortByBillAmountMin: "sortByBillAmountMin",
        sortByBillAmountMax: "sortByBillAmountMax",
      },
      isGrabOrderEnabled : false,
      isSilomPromotionEnabled : false,
      dataTopFivePromotion: [],
      dataTransection :[],
      dataUsageTransection :[],
      dataTopFiveGrabCanpaign :[],
      dataGrabCanpaignTransection :[],
      dataPromotionDetail :[],
      dataPromotionTransection :[],
      details: [],
      chart: null, // ECharts instance
      titlePromotion : '',
      showModal: false,
      transactions: [], // Data fetched from API
      lineLabels: [], // Line chart labels (dates)
      doughnutLabels: ["Total Discount", "Remaining Sales"], // Doughnut chart labels
      lineDatasets: [
        {
          label: "Discount Calculated ($)",
          backgroundColor: "rgba(99, 123, 255, 0.2)",
          borderColor: "rgba(99, 123, 255, 1)",
          data: [], // Discount data
        },
      ],
      doughnutDatasets: [
        {
          label: "Discount Distribution",
          backgroundColor: ["#36A2EB", "#FFCE56"],
          data: [], // Doughnut data
        },
      ],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      itemPromotion : {},
      promotionSummary: {
        totalUsage: 0,
        totalDiscount: 0,
        totalOrders: 0,
        totalRevenue: 0
      }
    };
  },
  computed: {
    ...mapGetters(["shops", "date", "users"]),
    
    // isGrabOrderEnabled() {
    //         return this.isGrabOrderEnabled 
    // },
    isPermission() {
            // return permis.findPermissionRead('inventory', this.$route.path)
            const shopObjectId = localStorage.getItem('shopObjectId');
            const selectedShop = this.shops.find(shop => shop.objectId === shopObjectId) || null
            let isSilomPromotionEnabled  = this.orderShopSetting?.promotionSetting?.enabled || false
            // return selectedShop?.currentPlan == "multiplePOS"  
            return isSilomPromotionEnabled
    },
    isExport() {
      return permis.findPermissionExport("report", this.$route.path);
    },
    sortAttr: {
      get() {
        let sortdata = this.sortdata;
        if (sortdata === "sortBySalesMin" || sortdata === "sortBySalesMax") {
          sortdata = "gpGrandTotal";
        }
        if (
          sortdata === "sortByBillAmountMin" ||
          sortdata === "sortByBillAmountMax"
        ) {
          sortdata = "bill";
        }
        return sortdata;
      },
      set(newValue) {
        return newValue;
      },
    },
    uid() {
      let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      return shop.uid;
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    startDate() {
      return moment(String(this.date.start)).format("DD MMMM YYYY");
    },
    endDate() {
      return moment(String(this.date.end)).format("DD MMMM YYYY");
    },
    fieldsDetail() {
      return [
        {
          key: "receiptNumber",
          label: this.$i18n.t("receiptNumber"),
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "pluCode",
          label: this.$i18n.t("pluCode"),
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "pluName",
          label: this.$i18n.t("productName"),
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "quantitySKU",
          label: this.$i18n.t("quantity"),
          _classes: "text-center font-weight-normal text-dark",
        },
        {
          key: "price",
          label: this.$i18n.t("priceUnit"),
          _classes: "text-right font-weight-normal text-dark",
        },
        {
          key: "discountTotal",
          label: this.$i18n.t("itemDiscount"),
          _classes: "text-right font-weight-normal text-dark",
        },
        {
          key: "totalAmount",
          label: this.$i18n.t("netAmount"),
          _classes: "text-right font-weight-normal text-dark",
        },
        {
          key: "netAmount",
          label: this.$i18n.t("totalAmount"),
          _classes: "text-right font-weight-normal text-dark",
        },

      ];
    },
    fieldsPayment() {
      return [
        {
          key: "paymentType",
          label: this.$i18n.t("paymentType"),
          _classes: "text-center text-dark",
        },
        {
          key: "paid",
          label: this.$i18n.t("paid"),
          _classes: "text-right text-dark",
        },
        {
          key: "change",
          label: this.$i18n.t("change"),
          _classes: "text-right text-dark",
        },
      ];
    },
    fields() {
      return [
        // {
        //   key: "id",
        //   label: this.$i18n.t("#"),
        //   _classes: "text-center text-dark font-weight-normal",
        //   _style: "width:5%",
        // },
        {
          key: "created_at",
          label: this.$i18n.t("date"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:10%",
        },
        {
            key: "receiptNumber",
            label: this.$i18n.t("receiptNumber"),
            _classes: "text-center text-dark font-weight-normal",
            _style: "width:10%",
        },
        {
          key: "promotionName",
          label: this.$i18n.t("promotionName"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:25%",
        },
        {
          key: "hasRef",
          label: this.$i18n.t("promotionCode"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:10%",
        },
        {
          key: "discountCalculated",
          label: this.$i18n.t("promotionDiscount"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:15%",
        },

        {
          key: "grandTotal",
          label: this.$i18n.t("grandTotal"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:15%",
        },
        {
          key: "status", // ✅ เพิ่มตรงนี้
          label: this.$i18n.t("status"),
          _classes: "text-center",
          _style: "width:10%",
        },
      ];
    },
    fieldsGrab() {
      return [
        {
          key: "created_at",
          label: this.$i18n.t("date"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:10%",
        },
        {
            key: "orderNo",
            label: this.$i18n.t("orderNo"),
            _classes: "text-center text-dark font-weight-normal",
            _style: "width:10%",
        },
        {
          key: "receiptNumber",
          label: this.$i18n.t("receiptNumber"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:10%",
        },
        {
          key: "promotionName",
          label: this.$i18n.t("promotionName"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:25%",
        },
        {
          key: "discountCalculated",
          label: this.$i18n.t("promotionDiscount"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:15%",
        },
      ];
    },
    fieldsPromotionStatus() {
      return [
        {
          key: "title",
          label: this.$i18n.t("promotionName"),
          _classes: "text-left text-dark font-weight-normal ",
          _style: "width:10%",
        },
        // {
        //   key: "promotionCode",
        //   label: this.$i18n.t("promotionCode"),
        //   _classes: "text-left text-dark font-weight-normal",
        //   _style: "width:10%",
        // },
        {
          key: "usageCount",
          label: this.$i18n.t("promotionTotal"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:15%",
        },

        {
          key: "totalCounttext",
          label: this.$i18n.t("promotionRemaining"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:15%",
        },
        {
          key: "startDate",
          label: this.$i18n.t("promotionStartDate"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:10%",
        },
        {
          key: "endDate",
          label: this.$i18n.t("PromotionEndDate"),
          _classes: "text-right text-dark font-weight-normal",
          _style: "width:10%",
        },
        
      ];
    },
   itemTopFivePromotion() {
    const promotion = this.dataTopFivePromotion || [];
    const topLabels = [];
    const topValues = [];
    const count = Math.min(promotion.length, 5);

    if (count > 0) {
        for (let i = 0; i < count; i++) {
            const promo = promotion[i];
            topLabels.push(promo.title);
            topValues.push(promo.usageCount);
        }
    } else {
        topLabels.push(this.$i18n.t("noData"));
        topValues.push(1);
    }

    return {
        labels: topLabels,
        datasets: [
            {
                // ใช้สีเดียวกับที่กำหนดใน Method getChartColor
                backgroundColor: count > 0 
                    ? ["#f9d4b4", "#dbbc8c", "#b49c74", "#9c7d5c", "#a47454"]
                    : ["#ebedef"],
                data: topValues,
                borderWidth: 2,
                borderColor: '#ffffff'
            },
        ],
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 70, // ปรับเป็น Doughnut เพื่อความสวยงาม
            scales: {
                        x: {
                            grid: {
                                display: false,
                            },
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                        y: {
                            grid: {
                                display: true,
                            },
                        },
                    },
                legend: {
                    display: false, // ปิด Legend เพราะเราใช้ Callout ด้านข้างแทนแล้ว
                },
            plugins: {

                tooltip: {
                    enabled: false,
                    callbacks: {
                        label: function (tooltipItem) {
                            if (count === 0) return this.$i18n.t("noData");
                            const value = tooltipItem.raw || 0;
                            return `${tooltipItem.label}: ${value}`;
                        },
                    },
                },
            },
        },
    };
},
    itemTopFiveGrabPromotion() {
        const promotion = this.dataTopFiveGrabCanpaign || [];
        
        const data = [];
        const topLabels = [];
        const topValues = [];

        const count = promotion.length >= 5 ? 5 : promotion.length;

        if (count > 0) {
            for (let i = 0; i < count; i++) {
                const promo = promotion[i];
                const object = {
                    quantity: promo.usageCount,
                    title: promo.title,
                };
                data.push(object);
                topValues.push(promo.usageCount);
                topLabels.push(promo.title);
            }
        } else {
            // No data fallback
            topLabels.push(this.$i18n.t("noData"));
            topValues.push(1); // Placeholder value
        }

        return {
            labels: topLabels,
            datasets: [
                {
                  // ? ["#E57A72", "#FFCAC9", "#D273FF", "#D4DDFF", "#0F4267"]

                    backgroundColor: count > 0 
                        ? ["#9FE2BF", "#73c6b6", "#D4DDFF", "#CCCCFF",  "#FFCAC9"]
                        : ["#ebedef"], // Neutral color for no data
                    data: topValues,
                },
            ],
            chartOptions: {
                responsive: true,
                height: 200,
                maintainAspectRatio: false,
                cutoutPercentage: 0, // Doughnut hole size
                scales: {
                    x: {
                        grid: {
                            display: false,
                        },
                        ticks: {
                            beginAtZero: true,
                        },
                    },
                    y: {
                        grid: {
                            display: true,
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: count > 0, // Hide default legend
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                if (count === 0) return this.$i18n.t("noData");
                                const value = tooltipItem.raw || 0;
                                return `${tooltipItem.label}: ${value}`;
                            },
                        },
                    },
                },
            },
        };
    },

    itemPromotionDetail() {
      const data = this.dataPromotionDetail || [];
      const detail = [];

      data.forEach((promotion) => {
        const hasRef = promotion.hasRef ?? "-";
        const usageCount = promotion.usageCount ?? 0;
        const totalCount = promotion.quotas?.totalCount ?? 0;
        let totalCounttext = totalCount;
        
        if (totalCount === -1 ) {
          totalCounttext = "∞";
        }else{
          totalCounttext = totalCount-usageCount;
        }
        // Format startDate and endDate if valid
        const startDate = promotion.startDate
          ? moment(String(promotion.startDate)).format("DD/MM/YYYY H:mm")
          : "-";
        const endDate = promotion.endDate
          ? moment(String(promotion.endDate)).format("DD/MM/YYYY H:mm")
          : "-";

        detail.push({
          image: promotion.details.remoteImagePath || '',
          title: promotion.details.title,
          promotionCode: hasRef,
          startDate,
          endDate,
          usageCount,
          totalCount,
          totalCounttext 
        });
      });

      return detail;
    },
    itemPromotionGrabDetail() {
      const data = this.dataPromotionDetail || [];
      const detail = [];

      data.forEach((promotion) => {
        const hasRef = promotion.hasRef ?? "-";
        const usageCount = promotion.usageCount ?? 0;
        const totalCount = promotion.quotas?.totalCount ?? 0;
        let totalCounttext = totalCount;
        
        if (totalCount === -1 ) {
          totalCounttext = "∞";
        }else{
          totalCounttext = totalCount-usageCount;
        }
        // Format startDate and endDate if valid
        const startDate = promotion.startDate
          ? moment(String(promotion.startDate)).format("DD/MM/YYYY H:mm")
          : "-";
        const endDate = promotion.endDate
          ? moment(String(promotion.endDate)).format("DD/MM/YYYY H:mm")
          : "-";

        detail.push({
          title: promotion.details.title,
          promotionCode: hasRef,
          startDate,
          endDate,
          usageCount,
          totalCount,
          totalCounttext 
        });
      });

      return detail;
    },
    itemPromotionTransection() {
      const data = this.dataPromotionTransection || [];
      const detail = [];

      data.forEach((promotion) => {
        
        const usageCount = promotion.usageCount ?? 0;
        const totalCount = promotion.quotas?.totalCount ?? 0;
        const orderNo = promotion.receipt.orderNo ?? "-";
        const promotionName = promotion.promotion.details.title ?? "-";
        const promotionDetail = promotion.promotion ?? '-'
        const hasRef = promotion.promotion.hasRef ?? "-";
        const discountCalculated = util.convertCurrency(promotion.discountCalculated )?? 0;
        const grandTotal = util.convertCurrency(promotion.receipt.grandTotal) ?? 0;
        const receiptNumber = promotion.receipt.receiptNumber ?? "-";
        // Format startDate and endDate if valid
        const created_at = promotion.created_at
          ? moment(String(promotion.created_at)).format("DD MMMM YYYY H:mm:ss")
          : "-";
        // 🔴 cancelled
        const cancelled_at = promotion.cancelled_at
          ? moment(promotion.cancelled_at).format("DD MMM YYYY HH:mm:ss")
          : "-";

        // 🔥 status
        const status = promotion.status || "SUCCESS";

        // 🎨 label สำหรับ UI
           const statusLabel =
          status === "CANCEL"
            ? this.$i18n.t("cancel")
            : this.$i18n.t("success");

        const statusColor =
          status === "CANCEL" ? "red" : "green";

          // Set Style
          let classess = "";
          let statusshow = this.$i18n.t("normal");

          if (promotion.status === "CANCEL") {
            statusshow = this.$i18n.t("cancel");
            classess = "text-danger";
          }
     
        detail.push(
          {
            created_at,
            receiptNumber,
            orderNo,
            promotionName,
            hasRef,
            discountCalculated,
            grandTotal,
            promotionDetail,
            status,
            _classes: classess,
            statusshow
          }
        );
      });
      return detail;
    },
    itemPromotionGrabTransection() {
      const data = this.dataGrabCanpaignTransection || [];

      const detail = [];

      data.forEach((promotion) => {
        const usageCount = promotion.usageCount ?? 0;
        const totalCount = promotion.quotas?.totalCount ?? 0;
        const orderNo = promotion.receipt.order.orderNumber ?? "-";
        const promotionName = promotion.campaign.name ?? "-";
        // const hasRef = promotion.promotion.details.hasRef ?? "-";
        const discountCalculated = util.convertCurrency(promotion.campaign.deductedAmount )?? 0;
        const grandTotal = util.convertCurrency(promotion.receipt.grandTotal) ?? 0;
        // Format startDate and endDate if valid
        const receiptNumber = promotion.receipt.receiptNumber ?? "-";
        const created_at = promotion.created_at
          ? moment(String(promotion.created_at)).format("DD MMMM YYYY H:mm:ss")
          : "-";
     
        detail.push(
          {
            created_at,
            orderNo,
            receiptNumber,
            promotionName,
            // hasRef,
            discountCalculated,
            grandTotal
          }
        );
      });
      
      return detail;
    },
   
  },
  created() {
    this.getOrderShopSetting()
    this.getTopFive()
    this.getPromotionDetail()
    this.getPromotionTransection()
    this.getGrabCanpaignTransection()
    this.getTopFiveGrabCanpaign()
    this.getPromotionSummary()
  },
  mounted() {
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // Remove resize listener
    if (this.chart) {
      this.chart.dispose(); // Dispose chart instance
    }
  },
  methods: {
    getChartColor(index) {
        const colors = ["#f9d4b4", "#dbbc8c", "#b49c74", "#9c7d5c", "#a47454"];
        return colors[index % colors.length];
    },
    // กำหนดสีพื้นหลังจางๆ ให้กับการ์ด
    getBackgroundColor(index) {
        const colors = ["#fffaf5", "#f9f6f0", "#f4f1ec", "#f0ede8", "#f3efeb"];
        return colors[index % colors.length];
    },
    getPromotionSummary() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid: uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end
      };

      const headers = {
        uid: uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId)
      };

      report({
        url: "/api/v2.0/promotions/transactions/summary",
        params: params,
        headers: headers,
        method: "GET"
      })
      .then((res) => {

        const summary = res.data.data || {};
        let discountCalculated = summary.discountCalculated || 0;
        let cancelDiscountCalculated = summary.cancelDiscountCalculated || 0;
        let totalDiscount = discountCalculated + cancelDiscountCalculated;


        // แมพค่าจาก JSON ที่คุณให้มา
        this.promotionSummary = {
          totalUsage: summary.count || 0,          // จำนวนทั้งหมด (16)
          totalOrders: summary.receiptCount || 0, // จำนวนบิล (8)
          totalRevenue: util.convertCurrency(summary.grandTotal || 0),  // ยอดรวมสุทธิ (12569)
          
          // ส่วนที่เพิ่มเข้ามาใหม่เพื่อ UI ที่ชัดเจนขึ้น
          successCount: summary.successCount || 0, // สำเร็จ (12)
          cancelCount: summary.cancelCount || 0,   // ยกเลิก (4)
          discountCalculatedtext : util.convertCurrency(summary.discountCalculated || 0),
          cancelDiscountCalculated : util.convertCurrency(cancelDiscountCalculated || 0),
          successDiscountCalculated : util.convertCurrency(summary.successDiscountCalculated || 0),
          successCalculated : util.convertCurrency(summary.successCalculated || 0),
          receiptCount : summary.receiptCount || 0,
          discountCalculated : summary.discountCalculated || 0,
          totalDiscounttext : util.convertCurrency(discountCalculated),
          dissountAvg: summary.count > 0 ? util.convertCurrency(summary.discountCalculated / summary.count) : 0, // ส่วนลดเฉลี่ยต่อการใช้โปรโมชั่น
        };

      })
      .catch((error) => {
        console.log(error);
      });
    },
    formatDate(dateString) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    getSort( keyword) {
        this.keyword = keyword
        this.getPromotionDetail()
    },
    getOrderShopSetting(){
        const shopObjectId = `${localStorage.getItem('shopObjectId')}`
        let params = {
            shopObjectId: shopObjectId,
        }
        const headers = {
            shopObjectId: util.sanitizeShopObjectId(shopObjectId),
        }
        pos({
            url: "/api/v3.0/shop/ordershopsetting",
            params: params,
            headers: headers,
            method: "get",
        }).then((res) => {            
            let isGrabOrderEnabled  = res.data.data.isGrabOrderEnabled
            if(isGrabOrderEnabled!== undefined && isGrabOrderEnabled !== null && isGrabOrderEnabled!==''){
                this.isGrabOrderEnabled = isGrabOrderEnabled
            }  
            let isSilomPromotionEnabled = res.data.data.promotionSetting?.enabled || false            
            // let isEnabled =  this.orderShopSetting?.isGrabOrderEnabled == true ||  selectedShop?.currentPlan == "multiplePOS" 
            this.isSilomPromotionEnabled = isSilomPromotionEnabled
            // this.isGrabOrderEnabled = true
        });
    },
    itemsDetail(index) {
      // let data = this.data[index].receiptItems;
      let info = [];
      // for (let i = 0; i < data.length; i++) {
      //     let discountBillPerQty = 0;
      //     let total = 0;
      //     let discountAmount = 0;

      //     if (data[i].deleted_at == null) {
      //     if (data[i].discountBillPerQty !== null) {
      //         discountBillPerQty = data[i].discountBillPerQty * data[i].quantity;
      //     }

      //     if (data[i].discountAmount !== null) {
      //         discountAmount = data[i].discountAmount;
      //     }
      //     total = data[i].netAmount - discountBillPerQty;
      //     let discountTotal = discountAmount + discountBillPerQty;

      //     info.push({
      //         receiptNumber: this.data[index].receiptNumber,
      //         pluCode: data[i].pluCode,
      //         pluName: data[i].pluName,
      //         orderedOptions: data[i].orderedOptions,
      //         quantitySKU: data[i].quantitySKU,
      //         price: util.convertCurrency(data[i].price),
      //         discountTotal: util.convertCurrency(discountTotal),
      //         totalAmount: util.convertCurrency(data[i].totalAmount),
      //         netAmount: util.convertCurrency(total),
      //     });
      //     }
      // }
      return info;
    },
    getTopFive(){
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "/api/v2.0/promotions/topfive",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.dataTopFivePromotion = res.data.data;
          this.loadingButton = true;
        })
        .catch((error) => {
          this.showChartLine = false;
          this.loadingButton = true;
          this.loading = false
        });
    },
    getPromotionDetail(page = 1){
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
        searchAttr : "details.title",
        searchVal : this.keyword,
        limit : 5,
        page: page,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "/api/v2.0/promotions/details",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.dataPromotionDetail = res.data.data;
          if (res.data.paginate.items == undefined) {
            this.meta_data_detail.items = 0;
          } else {
            this.meta_data_detail.items = res.data.paginate.items;
          }
          this.meta_data_detail.last_page = res.data.paginate.pageCount;
          this.meta_data_detail.current_page = res.data.paginate.currentPage;
          this.meta_data_detail.itemCount = res.data.paginate.itemCount;
          this.meta_data_detail.limit = res.data.paginate.perPage;

          
          this.loading = false;
          this.loadingButton = true;
        })
        .catch((error) => {
          console.log(error);
          this.showChartLine = false;
          this.loadingButton = true;
          this.loading = false;
        });

    },
    getPromotionTransection(page = 1){
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
        limit : 10,
        page: page,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "/api/v2.0/promotions/transactions",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.dataPromotionTransection = res.data.data;
          if (res.data.paginate.items == undefined) {
            this.meta_data.items = 0;
          } else {
            this.meta_data.items = res.data.paginate.items;
          }
          this.meta_data.last_page = res.data.paginate.pageCount;
          this.meta_data.current_page = res.data.paginate.currentPage;
          this.meta_data.itemCount = res.data.paginate.itemCount;
          this.meta_data.limit = res.data.paginate.perPage;

          this.loadingButton = true;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.showChartLine = false;
          this.loadingButton = true;
        });

    },
    setItemPromotionDetail (item){
        this.itemPromotion = item
    },
    getUsageTransection(item){
      const startDate = item.promotionDetail.startDate
          ? moment(String(item.promotionDetail.startDate)).format("DD MMMM YYYY")
          : "-";
        const endDate = item.promotionDetail.endDate
          ? moment(String(item.promotionDetail.endDate)).format("DD MMMM YYYY ")
          : "-";

        this.promotionStart  = startDate
        this.promotionEnd =  endDate

              
      this.promotionName = item.promotionName
      this.remoteImagePath = item.promotionDetail.details.remoteImagePath
      this.descriptionPromotion = item.promotionDetail.details.description
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
        // limit : 4,
        // page: this.meta_data_promotion_usage.current_page,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "api/v2.0/promotion/usage/transactions/" + item.promotionDetail.objectId,
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {

          const data = res.data.data;

          // Update Line Chart Data
          this.lineLabels = data.map((transaction) =>
            new Date(transaction.created_at).toLocaleDateString()
          );
          this.lineDatasets[0].data = data.map(
            (transaction) => transaction.receipt.grandTotal
          );

          // Update Doughnut Chart Data
          const totalDiscount = data.reduce(
            (sum, transaction) => sum + transaction.discountCalculated,
            0
          );
          const totalSales = data.reduce(
            (sum, transaction) => sum + transaction.receipt.grandTotal,
            0
          );
          this.transactions = data;
          this.doughnutDatasets[0].data = [totalDiscount, totalSales - totalDiscount];
          this.loadingButton = true;
          this.loading = false
          // meta_data_promotion_usage
          if (res.data.paginate.items == undefined) {
            this.meta_data_promotion_usage.items = 0;
          } else {
            this.meta_data_promotion_usage.items = res.data.paginate.items;
          }
          this.meta_data_promotion_usage.last_page = res.data.paginate.pageCount;
          this.meta_data_promotion_usage.current_page = res.data.paginate.currentPage;
          this.meta_data_promotion_usage.itemCount = res.data.paginate.itemCount;
          this.meta_data_promotion_usage.limit = res.data.paginate.perPage;
          this.showModal = true
          
        })
        .catch((error) => {
          console.log(error);
          this.showChartLine = false;
          this.loadingButton = true;
        });

    },
    getGrabCanpaignTransection(page = 1){
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
        page: page,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "/api/v2.0/grabcampaigns/transactions",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.dataGrabCanpaignTransection = res.data.data;
          if (res.data.paginate.items == undefined) {
            this.meta_data_grab.items = 0;
          } else {
            this.meta_data_grab.items = res.data.paginate.items;
          }
          this.meta_data_grab.last_page = res.data.paginate.pageCount;
          this.meta_data_grab.current_page = res.data.paginate.currentPage;
          this.meta_data_grab.itemCount = res.data.paginate.itemCount;
          this.meta_data_grab.limit = res.data.paginate.perPage;
          this.loadingButton = true;
        })
        .catch((error) => {
          console.log(error);
          this.showChartLine = false;
          this.loadingButton = true;
          this.loading = false
        });

    },
    getTopFiveGrabCanpaign(){
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;

      const params = {
        uid : uid,
        shopObjectId: shopObjectId,
        startAt: this.date.start,
        endAt: this.date.end,
      };
      const headers = {
        uid : uid,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };

      this.loading = true;
      report({
        url: "/api/v2.0/grabcampaigns/topfive",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.dataTopFiveGrabCanpaign = res.data.data;
          this.loadingButton = true;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.showChartLine = false;
          this.loadingButton = true;
        });

    },

    getData() {
      this.getOrderShopSetting()
      this.getTopFive()
      this.getPromotionDetail()
      this.getPromotionTransection()
      this.getGrabCanpaignTransection()
      this.getTopFiveGrabCanpaign()
      this.getPromotionSummary()
      },
    setSort(value) {
      this.sortdata = value;
    },
    prepareChartData() {
      let data = this.dataDate;
      const labels = [
        ...new Set(data.map((item) => moment(item.date).format("YYYY-MM-DD"))),
      ];
      if (labels.length == 1) {
        let firstDate = moment(labels[0], "YYYY-MM-DD")
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        labels.unshift(firstDate);
      }

      const groupedData = {};
      data.forEach((item) => {
        if (!groupedData[item.name]) {
          groupedData[item.name] = Array(labels.length).fill(0);
        }
        const dateIndex = labels.indexOf(
          moment(item.date).format("YYYY-MM-DD")
        );
        if (dateIndex !== -1) {
          groupedData[item.name][dateIndex] = item.gpGrandTotal;
        }
      });

      const datasets = Object.keys(groupedData).map((name, index) => ({
        label: name,
        data: groupedData[name],
        borderColor: this.getLineColor(index),
        fill: false,
        tension: 0.1,
      }));

      this.chartData = {
        labels: labels,
        datasets: datasets,
      };
    },

    getLineColor(index) {
      const colors = [
        "#AEC6CF", // Pastel Blue
        "#FFB347", // Pastel Orange
        "#77DD77", // Pastel Green
        "#FF6961", // Pastel Red
        "#F49AC2", // Pastel Pink
        "#CFCFC4", // Pastel Gray
        "#FDFD96", // Pastel Yellow
        "#84B6F4", // Pastel Light Blue
        "#C4A7E7", // Pastel Purple
        "#FFD1DC", // Pastel Light Pink
        "#B39EB5", // Pastel Mauve
        "#FFDAC1", // Pastel Peach
        "#B0E57C", // Pastel Lime Green
        "#E0BBE4", // Pastel Lavender
      ];
      return colors[index % colors.length];
    },
    toggleDetails(item, index) {

      // const position = this.details.indexOf(item);
      //   this.order(index)
      //   this.paymentDetail(item.paymentObjectId)
      // position !== -1
      //   ? this.details.splice(position, 1)
      //   : this.details.push(item);
    },
  },
  filters: {
    currency(value) {
      return `$${Number(value).toFixed(2)}`;
    },
  },
};
</script>

<style scoped>
.chart-container {
  height: 400px;
  position: relative;
}
</style>
<style src="../../assets/styles/inventory.css" scoped></style>
<style>
.square-box {
    position: relative;
    width: 20%;
    overflow: hidden;
    border-radius: 3px;
}

.square-box:before {
    content: '';
    display: block;
    padding-top: 100%;
}

.card[data-v-08db0b29] {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.line-btn {
    width: 180px;
    background-color: #00ba01;
    display: flex;
    align-items: center;
    color: white;
    border-radius: 7px;
}

.vue__time-picker {
    width: 10em;
}

.vue__time-picker input.display-time {
    width: 10em;
}

@media only screen and (max-width: 600px) {

    .vue__time-picker,
    .vue__time-picker input.display-time {
        width: 5em;
    }
}

.tabs .slider {
    position: relative;
    width: 50%;
    transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
}

.time-picker-header {
    height: 35px;
    overflow: hidden;
    border: 1px solid #ebedef;
    background-color: #f6f6f6;
}
.modal-item-detail{
  position: fixed !important;
  right: 24px !important;
  width: 30%;
  align-items: normal;
}
.modern-stat-card {
  border-radius: 16px;
  overflow: hidden;
  min-height: 100px;
}

.stat-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
}

.stat-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

/* Vertical Progress Bar Styling */
.progress-vertical {
  width: 24px;
  height: 60px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  margin-left: 15px;
}

.progress-bar-inner {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-radius: 12px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: height 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.progress-text {
  font-size: 0.6rem;
  color: #fff;
  font-weight: 800;
  margin-bottom: 4px;
  transform: rotate(0deg);
}

/* Light background colors for progress containers */
.bg-light-info { background-color: #e3f2fd !important; }
.bg-light-danger { background-color: #ffebee !important; }
.bg-light-success { background-color: #e8f5e9 !important; }
.bg-light-warning { background-color: #fff8e1 !important; }

/* เพิ่มความหนาของ Border ด้านซ้าย */
.border-left-info { border: 1px solid #3399ff !important;border-left: 10px solid #3399ff !important; }
.border-left-danger { border: 1px solid #e55353 !important; border-left: 10px solid #e55353 !important; }
.border-left-success { border: 1px solid #2eb85c !important; border-left: 10px solid #2eb85c !important; }
.border-left-warning { border: 1px solid #f9b115 !important; border-left: 10px solid #f9b115 !important; }

.modern-stat-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.modern-stat-card:hover {
  transform: translateX(5px); /* เปลี่ยนเป็นเลื่อนขวาเล็กน้อยเพื่อให้เข้ากับ border-left */
  box-shadow: 0px 10px 20px rgba(0,0,0,0.1) !important;
}

/* ส่วนประกอบอื่นๆ คงเดิมตามสไตล์ที่คุณชอบ */
.progress-vertical {
  width: 20px;
  height: 70px;
  border-radius: 20px;
  background-color: #f1f3f5;
  position: relative;
  overflow: hidden;
}

.progress-bar-inner {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: height 0.5s ease-in-out;
}

.progress-text {
  font-size: 0.55rem;
  color: #fff;
  font-weight: bold;
  margin-bottom: 3px;
}
.img-wrapper {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f8f9fa;
}
.promo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>

